import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Col from "../../components/Col";
import Row from "../../components/Row";

import Select from "../../components/Select";
import Picker from "../../components/Picker";
import {
  fetchReports,
  clearReports,
  fetchUserActivityReport,
  fetchUserStatusReports,
  fetchCustomerFeedback,
} from "../../store/actions/serviceRequests";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { selectProperties } from "../../store/selectors/properties";
import { Multiselect } from "multiselect-react-dropdown";
import Icon from "../../components/Icon";
import "./Reporting.scss";
import ReportingTable from "../../components/ReportingTable/ReportingTable";
import Button from "../../components/Button";
import moment from "moment";
import { CSVLink } from "react-csv";
import ReportingUserActivityTable from "../../components/ReportingTable/ReportingUserActivityTable";
import Loader from "../../components/Loader";
import { selectLoader } from "../../store/selectors/loader";
import UserStatusReports from "../../components/ReportingTable/UserStatusReports";
import CustomerFeedbackReportTable from "../../components/ReportingTable/CustomerFeedbackTable";
import { ServiceRequestStatsForm } from "./Forms/ServiceRequestStats/index.jsx";
import { ServiceRequestStatsReport } from "./Forms/ServiceRequestStats/Report.jsx";
import { clearServiceRequestStats } from "../../store/actions/serviceRequestStats.js";
import { ServiceRequestStatsReportSidebar } from "./Forms/ServiceRequestStats/ReportSidebar.jsx";

let types = [
  { label: "Reporting", value: "Reporting" },
  { label: "User Activity", value: "User Activity" },
  { label: "User Status Report", value: "User Status Report" },
  { label: "Customer Feedback Report", value: "Customer Feedback Report" },
  { label: "Service Request Report", value: "Service Request Report" },
];
let headers = [
  { label: "Client", key: "propertyName" },
  { label: "Service Request ID", key: "ticketNumber" },
  { label: "Service Request Status", key: "status" },
  { label: "Service Request Age", key: "serviceRequestAge" },
  { label: "Service Request Created Date", key: "createdDate" },
  { label: "Service Request Closed Date", key: "closedDate" },
  { label: "Estimated Time", key: "estimatedTime" },
  { label: "Actual Time", key: "actualTime" },
];
let userActivityHeaders = [
  { label: "User/Account", key: "userName" },
  { label: "Date", key: "date" },
  { label: "Event", key: "event" },
  { label: "Time", key: "time" },
  { label: "Session Time", key: "sessionTime" },
];

let userStatusReportsHeaders = [
  { label: "Property", key: "propertyName" },
  {
    label: localStorage.getItem("theme") === "Shape" ? "Unit" : "Suite",
    key: "suiteName",
  },
  { label: "Name", key: "name" },
  { label: "Email", key: "email" },
  { label: "Phone", key: "phone" },
  { label: "Status", key: "status" },
  { label: "Designation", key: "designation" },
];
let customerFeedBackHeaders = [
  { label: "Service Request Id", key: "ticketNumber" },
  { label: "User/Account", key: "userName" },
  { label: "Email", key: "email" },
  { label: "Rating", key: "rating" },
  { label: "Feedback", key: "feedback" },
  { label: "Date ", key: "createdOn" },
];

class ReportingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      propertyId: "",
      selectedValues: [],
      fromDate: null,
      toDate: new Date(),
      type: "Reporting",
    };
  }
  componentDidMount() {
    this.props.onClearReports();
    this.props.onClearServiceRequestStats();
  }
  onSelect = (selectedList, selectedItem) => {
    this.setState({ selectedValues: selectedList });
  };
  onRemove = (selectedList, removedItem) => {
    this.setState({ selectedValues: selectedList });
  };
  generateReport = () => {
    let selectedValues = this.state.selectedValues;
    if (this.state.type === "User Status Report") {
      let propertyIds = "";
      selectedValues.forEach((s) => {
        if (s.id) {
          propertyIds = propertyIds.concat(`${propertyIds && "&"}${s.id}`);
        }
      });
      this.props.onFetchUserStatusReports(propertyIds);
    } else if (this.state.type === "Customer Feedback Report") {
      let propertyIds = [];
      selectedValues.forEach((s) => {
        if (s.id) {
          let data = {
            propertyId: s.id,
          };
          propertyIds = [...propertyIds, data];
        }
      });

      let params = {
        propertyIds: propertyIds,
        fromDate: moment(this.state.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.state.toDate).format("YYYY-MM-DD"),
      };
      this.props.onCustomerFeedBackReport(params);
    } else {
      let propertyIds = [];
      selectedValues.map((s) => {
        if (s.id) {
          let data = {
            propertyId: s.id,
          };
          propertyIds = [...propertyIds, data];
        }
      });
      let params = {
        propertyIds: propertyIds,
        fromDate: moment(this.state.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.state.toDate).format("YYYY-MM-DD"),
      };
      this.props.onClearReports();
      if (this.state.type === "Reporting") {
        this.props.onfetchReports(params);
      } else {
        this.props.onFetchUserActivityReport(params);
      }
    }
  };
  render() {
    const { properties, reports, feedbackReport } = this.props;
    const { type } = this.state;
    const reportHeaders =
      type === "Reporting"
        ? headers
        : type === "User Status Report"
        ? userStatusReportsHeaders
        : type === "Customer Feedback Report"
        ? userStatusReportsHeaders
        : userActivityHeaders;
    const fileName =
      type === "User Status Report" ? "UserStatusReport.csv" : "Report.csv";
    return (
      <Row>
        <Col xs="12" md="6">
          <Select
            value={type}
            onChange={(e) => {
              this.setState({ type: e.target.value });
              this.props.onClearReports();
              this.props.onClearServiceRequestStats();
            }}
            options={types.map((item) => ({
              label: item.label,
              value: item.value,
            }))}
            label="Select Reporting Type"
            placeholder="Select Reporting Type"
            block
          />
          {type === "Service Request Report" ? (
            <ServiceRequestStatsForm />
          ) : (
            <>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="reporting__heading">SELECT PROPERTIES</div>
                {type !== "User Status Report" && (
                  <div className="picker__required" />
                )}
              </div>
              <Multiselect
                options={properties.map((property) => ({
                  name: property.name,
                  id: property.id,
                }))}
                displayValue="name"
                selectedValues={this.state.selectedValues}
                placeholder="Select Property"
                onSelect={this.onSelect}
                onRemove={this.onRemove}
              />
              {type !== "User Status Report" && (
                <>
                  <div className="reporting__heading">SELECT REPORT DATES</div>
                  <Picker
                    label="From Date"
                    required={true}
                    showPopperArrow={false}
                    placeholderText="From Date"
                    selected={this.state.fromDate}
                    onChange={(date) => this.setState({ fromDate: date })}
                  />
                  <Picker
                    label="To Date"
                    required={true}
                    showPopperArrow={false}
                    placeholderText="To Date"
                    selected={this.state.toDate}
                    onChange={(date) => this.setState({ toDate: date })}
                  />
                </>
              )}
              <div style={{ marginBottom: 20 }} />
              {type !== "Customer Feedback Report" && (
                <Button
                  color="teal"
                  size="small"
                  label="Generate Report"
                  disabled={
                    type === "User Status Report"
                      ? false
                      : !this.state.selectedValues.length ||
                        !this.state.fromDate
                  }
                  onClick={() => this.generateReport()}
                />
              )}
              {type === "Customer Feedback Report" && (
                <Button
                  color="teal"
                  size="small"
                  label="Generate Report"
                  disabled={!this.state.toDate || !this.state.fromDate}
                  onClick={() => this.generateReport()}
                />
              )}
            </>
          )}
        </Col>
        <Col xs="12" md="6">
          <div
            style={{
              justifyContent: "flex-end",
              alignItems: "center",
              marginRight: 20,
              display: "flex",
              flexDirection: "row",
            }}
          >
            {reports && reports.length > 0 && (
              <div
                style={{
                  justifyContent: "flex-end",
                  display: "flex",
                  margin: 5,
                }}
              >
                <CSVLink
                  data={reports}
                  asyncOnClick={true}
                  headers={reportHeaders}
                  separator={","}
                  filename={fileName}
                >
                  {" "}
                  <div
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      margin: 5,
                    }}
                  >
                    <div style={{ paddingRight: 10 }}>Download Report</div>
                    <Icon glyph="cloud-download" weight="regular" size="big" />
                  </div>
                </CSVLink>
              </div>
            )}
            {feedbackReport && feedbackReport.length > 0 && (
              <div
                style={{
                  justifyContent: "flex-end",
                  display: "flex",
                  margin: 5,
                }}
              >
                <CSVLink
                  data={feedbackReport}
                  asyncOnClick={true}
                  headers={customerFeedBackHeaders}
                  separator={","}
                  filename={fileName}
                >
                  {" "}
                  <div
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                      margin: 5,
                    }}
                  >
                    <div style={{ paddingRight: 10 }}>Download Report</div>
                    <Icon glyph="cloud-download" weight="regular" size="big" />
                  </div>
                </CSVLink>
              </div>
            )}
            <ServiceRequestStatsReportSidebar />
          </div>
        </Col>
        <div style={{ marginTop: 20 }}>
          {this.props.loader && (
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <Loader loading={true} center={true} />
            </div>
          )}
          {type === "Reporting" && (
            <ReportingTable reports={this.props.reports} from="Property" />
          )}
          {type === "User Activity" && (
            <ReportingUserActivityTable
              reports={this.props.reports}
              from="Property"
            />
          )}
          {type === "User Status Report" && (
            <UserStatusReports reports={this.props.reports} />
          )}
          {type === "Customer Feedback Report" && (
            <CustomerFeedbackReportTable reports={this.props.feedbackReport} />
          )}
          <ServiceRequestStatsReport />
        </div>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: selectAuthenticatedUser(state),
    properties: selectProperties(state),
    reports: state.reports,
    feedbackReport: state.feedbackReport,
    loader: selectLoader(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClearReports: clearReports,
      onClearServiceRequestStats: clearServiceRequestStats,
      onfetchReports: fetchReports,
      onFetchUserActivityReport: fetchUserActivityReport,
      onFetchUserStatusReports: fetchUserStatusReports,
      onCustomerFeedBackReport: fetchCustomerFeedback,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ReportingForm);
